(function () {
  function ensureSellingPlanInput(form) {
    if (!form) return null;
    let input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.appendChild(input);
    }
    return input;
  }

  function formatMoney(cents, format) {
    if (format == null) format = '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var absolute = Math.abs(Number(cents));
    var value = (Math.round(absolute) / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    var amount = dollars + '.' + parts[1];
    var amountNoDecimals = String(Math.round(absolute / 100)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return amount;
    switch (match[1]) {
      case 'amount':
        return format.replace(placeholder, amount);
      case 'amount_no_decimals':
        return format.replace(placeholder, amountNoDecimals);
      case 'amount_with_comma_separator':
        return format.replace(placeholder, parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ',' + parts[1]);
      case 'amount_no_decimals_with_comma_separator':
        return format.replace(placeholder, String(Math.round(absolute / 100)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.'));
      default:
        return format.replace(placeholder, amount);
    }
  }

  function getProductForm(root) {
    const formId = root.dataset.productFormId;
    return formId
      ? document.getElementById(formId)
      : document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function getUnitData(root) {
    if (root._unitData) return root._unitData;
    const node = root.querySelector('[data-buybox-unit-data]');
    if (!node) return null;
    try {
      root._unitData = JSON.parse(node.textContent);
      root._unitData.moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    } catch (e) {
      root._unitData = null;
    }
    return root._unitData;
  }

  function getCurrentVariant(root) {
    const data = getUnitData(root);
    if (!data || !data.variants) return null;
    const form = getProductForm(root);
    const rawId = form?.querySelector('[name="id"]')?.value;
    if (rawId == null || rawId === '') return null;
    const variantId = Number(rawId);
    if (!variantId) return null;
    return (
      data.variants.find(function (entry) {
        return entry.id === variantId;
      }) || null
    );
  }

  function getPlanEntries(variant) {
    if (!variant || !variant.plans) return [];
    return Object.keys(variant.plans).map(function (id) {
      const plan = variant.plans[id];
      return {
        id: id,
        price: plan.price,
        compare_at: plan.compare_at,
        discount: plan.discount || 0,
        name: plan.name || '',
      };
    });
  }

  function syncDiscountBadge(root) {
    const badge = root.querySelector('[data-buybox-discount-badge]');
    if (!badge) return;

    const frequency = root.querySelector('[data-buybox-frequency]');
    const selected = frequency && frequency.selectedOptions && frequency.selectedOptions[0];
    const percent = selected ? Number(selected.dataset.discountPercent || 0) : 0;
    const label = root.dataset.discountLabel || '';

    if (percent > 0) {
      badge.textContent = label ? percent + '% ' + label : percent + '%';
      badge.hidden = false;
    } else {
      badge.textContent = '';
      badge.hidden = true;
    }
  }

  function syncDiscountBenefit(root) {
    const item = root.querySelector('[data-buybox-discount-benefit]');
    const text = root.querySelector('[data-buybox-discount-benefit-text]');
    if (!item || !text) return;

    const frequency = root.querySelector('[data-buybox-frequency]');
    const selected = frequency && frequency.selectedOptions && frequency.selectedOptions[0];
    const percent = selected ? Number(selected.dataset.discountPercent || 0) : 0;

    if (percent > 0) {
      text.textContent = percent + '% off on recurring orders';
      item.hidden = false;
    } else {
      text.textContent = '';
      item.hidden = true;
    }
  }

  function syncPrices(root) {
    const variant = getCurrentVariant(root);
    const data = getUnitData(root);
    const originalEl = root.querySelector('[data-buybox-price-original]');
    const currentEl = root.querySelector('[data-buybox-price-current]');
    const onetimeEl = root.querySelector('[data-buybox-price-onetime]');
    if (!data) return;

    if (!variant) {
      if (onetimeEl) onetimeEl.textContent = '';
      if (currentEl) currentEl.textContent = '';
      if (originalEl) {
        originalEl.textContent = '';
        originalEl.hidden = true;
      }
      return;
    }

    const moneyFormat = data.moneyFormat;
    const frequency = root.querySelector('[data-buybox-frequency]');
    const planId = frequency && frequency.value;
    const plan = planId && variant.plans ? variant.plans[planId] : null;

    const onetimePrice = variant.price;
    let currentPrice = onetimePrice;
    let compareAt = onetimePrice;

    if (plan) {
      currentPrice = plan.price;
      compareAt = plan.compare_at != null ? plan.compare_at : onetimePrice;
    }

    if (onetimeEl) onetimeEl.textContent = formatMoney(onetimePrice, moneyFormat);
    if (currentEl) currentEl.textContent = formatMoney(currentPrice, moneyFormat);
    if (originalEl) {
      if (compareAt > currentPrice) {
        originalEl.textContent = formatMoney(compareAt, moneyFormat);
        originalEl.hidden = false;
      } else {
        originalEl.hidden = true;
      }
    }
  }

  function syncUnitPrice(root) {
    const item = root.querySelector('[data-buybox-unit-price]');
    const text = root.querySelector('[data-buybox-unit-price-text]');
    const data = getUnitData(root);
    const variant = getCurrentVariant(root);
    if (!item || !text) return;

    if (!data || !variant || !variant.weight) {
      item.hidden = true;
      return;
    }

    let price = variant.price;
    const planId = root.querySelector('[data-buybox-frequency]')?.value;
    if (planId && variant.plans && variant.plans[planId] != null) {
      price = variant.plans[planId].price;
    }

    const unitCents = price / variant.weight;
    text.textContent = formatMoney(unitCents, data.moneyFormat) + '/g';
    item.hidden = false;
  }

  function setSubscribeAvailability(root, available) {
    const subscribe = root.querySelector('[data-buybox-select="subscribe"]');
    const subscribeRadio = root.querySelector('[data-buybox-mode="subscribe"]');
    const frequencyWrap = root.querySelector('[data-buybox-frequency-wrap]');

    root.dataset.hasSellingPlans = available ? 'true' : 'false';
    root.classList.toggle('buybox--no-plans', !available);

    if (subscribe) {
      subscribe.hidden = !available;
      subscribe.classList.toggle('buybox__subscribe--unavailable', !available);
    }
    if (subscribeRadio) subscribeRadio.disabled = !available;
    if (frequencyWrap) frequencyWrap.hidden = !available;
  }

  function reconcileSellingPlans(root) {
    const variant = getCurrentVariant(root);
    const frequency = root.querySelector('[data-buybox-frequency]');
    const plans = getPlanEntries(variant);
    const available = plans.length > 0;

    setSubscribeAvailability(root, available);

    if (!frequency) return available;

    const previous = frequency.value;
    frequency.innerHTML = '';

    plans.forEach(function (plan, index) {
      const option = document.createElement('option');
      option.value = plan.id;
      option.textContent = plan.name;
      option.dataset.discountPercent = String(plan.discount || 0);
      if (plan.id === previous || (!previous && index === 0)) {
        option.selected = true;
      }
      frequency.appendChild(option);
    });

    if (previous && !plans.some(function (plan) { return plan.id === previous; }) && plans[0]) {
      frequency.value = plans[0].id;
    }

    return available;
  }

  function syncSellingPlan(root) {
    const form = getProductForm(root);
    const input = ensureSellingPlanInput(form);
    if (!input) return;

    const mode = root.dataset.mode;
    const hasPlans = root.dataset.hasSellingPlans === 'true';
    const frequency = root.querySelector('[data-buybox-frequency]');

    if (mode === 'subscribe' && hasPlans && frequency && frequency.value) {
      input.disabled = false;
      input.value = frequency.value;
    } else {
      input.value = '';
      input.disabled = true;
    }

    syncDiscountBadge(root);
    syncDiscountBenefit(root);
    syncPrices(root);
    syncUnitPrice(root);

    window.debugLog?.('[BuyBox]', { mode: mode, selling_plan: input.disabled ? null : input.value });
  }

  function syncSubmitLabel(root) {
    const form = getProductForm(root);
    const button = form?.querySelector('[name="add"]');
    const textEl = button?.querySelector('span');
    if (!textEl || !button || button.hasAttribute('disabled')) return;

    textEl.textContent =
      root.dataset.mode === 'subscribe'
        ? 'ADD SUBSCRIPTION'
        : window.variantStrings?.addToCart || 'Add to cart';
  }

  function setMode(root, mode) {
    if (mode !== 'subscribe' && mode !== 'onetime') return;
    if (mode === 'subscribe' && root.dataset.hasSellingPlans !== 'true') {
      mode = 'onetime';
    }

    root.dataset.mode = mode;
    root.classList.remove('buybox--mode-subscribe', 'buybox--mode-onetime');
    root.classList.add(mode === 'subscribe' ? 'buybox--mode-subscribe' : 'buybox--mode-onetime');

    const radio = root.querySelector('[data-buybox-mode="' + mode + '"]');
    if (radio && !radio.disabled) radio.checked = true;

    syncSellingPlan(root);
    syncSubmitLabel(root);
  }

  function onVariantChange(root) {
    const available = reconcileSellingPlans(root);
    setMode(root, available ? root.dataset.mode || 'subscribe' : 'onetime');
  }

  function initBuybox(root) {
    if (root.dataset.buyboxReady === 'true') return;
    root.dataset.buyboxReady = 'true';

    root.addEventListener('change', function (event) {
      const modeInput = event.target.closest('[data-buybox-mode]');
      if (!modeInput || !root.contains(modeInput)) return;
      setMode(root, modeInput.getAttribute('data-buybox-mode'));
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest('select[data-buybox-frequency]')) return;
      if (event.target.closest('[data-buybox-mode]')) return;

      const option = event.target.closest('[data-buybox-select]');
      if (!option || !root.contains(option)) return;
      if (option.hasAttribute('hidden')) return;

      setMode(root, option.getAttribute('data-buybox-select'));
    });

    const frequency = root.querySelector('[data-buybox-frequency]');
    if (frequency) {
      frequency.addEventListener('change', function () {
        setMode(root, 'subscribe');
      });
    }

    const form = getProductForm(root);
    const variantInput = form?.querySelector('[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', function () {
        onVariantChange(root);
      });
    }

    reconcileSellingPlans(root);
    setMode(root, root.dataset.hasSellingPlans === 'true' ? root.dataset.mode || 'subscribe' : 'onetime');
  }

  function initAll() {
    document.querySelectorAll('[data-buybox]').forEach(initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      document.querySelectorAll('[data-buybox]').forEach(syncSubmitLabel);
    });
  }
})();
